import { NavLink } from "react-router-dom"
import Button from "./Button"
import logo from "../logo.png"
import Facebook from '@material-ui/icons/Facebook';
import LinkedIn from '@material-ui/icons/LinkedIn';
import Email from '@material-ui/icons/Email';
import GitHub from '@material-ui/icons/GitHub';
import Search from './Search'

export default function Header() {
    return (
        <>
            <header className="header">
                <div className="logo">
                    <NavLink to="/" exact  className="navlogo " >
                        <img  src={logo} alt="..." />
                    </NavLink>
                </div>
                <div className="btn">
                    <NavLink to="/contact-us" activeClassName="activeBtn" className="bg-green-500 py-2 px-7 rounded shadow transition-all duration-300  hover:bg-transparent hover:text-green-500 border-green-500 mr-4 " >
                        <button >Let's Talk</button>
                    </NavLink>
                </div>
            </header>
                {/* <Search /> */}
            <ul className="linkss py-2 px-7  " style={{display: 'flex',justifyContent: 'center', alignItems: 'center'}} >
                    <li><a href="https://www.facebook.com/profile.php?id=100006604579009"><Facebook /></a></li>
                    <li><a href="https://www.linkedin.com/in/asaf-shapira-fullstack-developer"><LinkedIn /></a></li>
                    <li><a href="dna0187@gmail.com"><Email /></a></li>
                    <li><a href="https://github.com/superas0187/superas0187"><GitHub /></a></li>
                </ul>
            <hr /> 
            <header className="header" style={{display: 'flex',justifyContent: 'center', padding: '20px' }}>
                <nav >
                    <ul >
                        <li><NavLink to="/about-us" activeClassName=" text-green-500 " >About</NavLink></li>
                        <li><NavLink to="/contact-us" activeClassName="text-green-500" >Experience</NavLink></li>
                        <li><NavLink to="/blog" activeClassName="text-green-500" >Blog</NavLink></li>
                        <li><NavLink to="/portfolio" activeClassName="text-green-500" >Portfolio</NavLink></li>
                    </ul>
                    
                </nav>
            </header> 
        </>
    )
}
 